import { render, staticRenderFns } from "./AMSTableTitle.vue?vue&type=template&id=336fd15c&"
import script from "./AMSTableTitle.vue?vue&type=script&lang=ts&"
export * from "./AMSTableTitle.vue?vue&type=script&lang=ts&"
import style0 from "./AMSTableTitle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/project/xunjie/ams_old/ams-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VAlert,VBtn,VDataTable,VFlex,VIcon,VLayout})
